import {StockLevelOverwrite} from '@hconnect/common/types'
import type {Moment} from 'moment-timezone'
import React from 'react'

import {useResizableChartWidth} from '../../../../../shared/components/d3chart/utils'
import {StockDevelopmentChartConfigProvider} from '../../../../../shared/components/stockDevelopmentChart/StockDevelopmentChartConfigProvider'
import {StockDevelopmentChartContent} from '../../../../../shared/components/stockDevelopmentChart/StockDevelopmentChartContent'
import {useStockDevelopmentChartConfigData} from '../../../../../shared/components/stockDevelopmentChart/utils/useStockDevelopmentChartConfigData'
import type {IncomingMaterial} from '../../../../../shared/selectors/materialOrders'
import type {StockDevelopmentData} from '../../../../../shared/selectors/stockDevelopment'

interface PlanningStockDevelopmentChartProps {
  timezoneId: string
  listOfDays: Moment[]
  stockData: StockDevelopmentData & {
    stockOverwrites?: StockLevelOverwrite[]
  }
  height: number
  minTargetLevels?: {weekend: number; week: number}
  deadStockLevel?: number
  storageCapacity?: number
  incomingMaterialHourly?: Record<string, IncomingMaterial[]>
}

export const PlanningStockDevelopmentChart: React.FC<PlanningStockDevelopmentChartProps> = ({
  timezoneId,
  listOfDays,
  stockData,
  minTargetLevels,
  deadStockLevel,
  storageCapacity,
  incomingMaterialHourly,
  height
}) => {
  const [chartRef, width] = useResizableChartWidth()

  const stockDevelopmentData = useStockDevelopmentChartConfigData({
    stockData,
    listOfDays,
    timezoneId,
    minTargetLevels,
    storageCapacity,
    height,
    width
  })

  return (
    <StockDevelopmentChartConfigProvider {...stockDevelopmentData}>
      <StockDevelopmentChartContent
        listOfDays={listOfDays}
        stockData={stockData}
        minTargetLevels={minTargetLevels}
        deadStockLevel={deadStockLevel}
        storageCapacity={storageCapacity}
        height={height}
        width={width}
        chartRef={chartRef}
        incomingMaterialHourly={incomingMaterialHourly}
      />
    </StockDevelopmentChartConfigProvider>
  )
}
